import JsBarcode, { Options } from 'jsbarcode'

export class BarcodeService {
  /**
   * Generates a barcode image for sale receipts.
   *
   * @method generateBarcodeImage
   *
   * @param {Object} params
   *
   *        @param {String} params.value
   *               The receipt number details value for the sale.
   *
   *        @param {String} params.options
   *               The options for the barcode.
   *
   * @return {String}
   *         The image src for the barcode
   */
  public generateBarcodeImage({
    value,
    options,
  }: {
    value: string
    options: Options
  }) {
    const el = document.createElement('img')
    if (value !== '') {
      JsBarcode(el, value, options)
    }
    return el.src.toString()
  }
}
